import axios from 'axios'
import qs from 'querystringify'
import { Message } from 'element-ui'
import {getCookiesData} from '../utils/common'
console.log( process.env.VUE_APP_LOGININURL)
axios.defaults.timeout = 3000000 // 5分钟
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
// axios.defaults.baseURL = 'https://tr.esread.com/'
// console.log('token:' + getCookiesData('researchToken'))
// http request 拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': getCookiesData('researchToken')
      }
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data)
        } else {
          reject(response.data)
          Message.error(response.data.code_msg)
        }
      })
      .catch(err => {
        reject(err)
        // console.log(err)
        Message.error('网络出错，请重试！')
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    data = qs.stringify(data)
    axios.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': getCookiesData('researchToken')
      }
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data)
        } else {
          reject(response.data)
          Message.error(response.data.code_msg)
        }
      })
      .catch(err => {
        reject(err)
        Message.error('网络出错，请重试！')
      })
  })
}

/**
 * 封装post—— json格式请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function jsonPost (url, data = {}) {
  return new Promise((resolve, reject) => {
    data = JSON.stringify({"data": data})
    axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getCookiesData('researchToken')
      }
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data)
          Message.closeAll()
        } else {
          reject(response.data)
          Message.error(response.data.code_msg)
        }
      })
      .catch(err => {
        reject(err)
        // Message.error('网络出错，请重试！')
      })
  })
}

/**
 * 封装post-上传文件请求
 * @param {*} url
 * @param {*} data
 * @returns {Promise}
 */
export function uploadPost (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': getCookiesData('researchToken')
      }
    })
      .then(response => {
        if (response.data.code === 0) {
          resolve(response.data)
        } else {
          reject(response.data)
          Message.error(response.data.code_msg)
        }
      })
      .catch(err => {
        reject(err)
        Message.error('网络出错，请重试！')
      })
  })
}
